import React from 'react'

const Order = (props) => (
    <ul className={"actions " + (props.fixed ? 'fixedButton' :'')}>
        <li><div className="button  special fit order-button"  data-glf-cuid="534c17d7-7092-4552-b6f2-8a0c4295937a" data-glf-ruid="60266ba6-c731-4b67-9842-e4760318ff07" >Karte & Bestellen</div></li>
    </ul>
)


export default Order